import { useMemo } from 'react';
import type { HistogramData, HistogramHighlight } from '../types';
import { bucketSeries, emptyBuckets, tonesOf, yScaleFor } from './buckets';

const everySeries = () => true;

export const useBuckets = ({
  data,
  n,
  height,
  filterIds,
  highlights,
  scaleToAll,
}: {
  data: HistogramData;
  n: number;
  height: number;
  filterIds: string[] | null;
  highlights: HistogramHighlight[] | null;
  scaleToAll: boolean;
}) =>
  useMemo(() => {
    if (n === 0) {
      return { base: emptyBuckets(0, tonesOf(data)), layers: [], yScale: 0 };
    }
    const ids = filterIds ? new Set(filterIds) : null;
    const base = bucketSeries(data, n, (s) => !ids || ids.has(s.id));
    const layers = (highlights ?? []).map((h) => ({
      key: h.key,
      buckets: bucketSeries(data, n, (s) => h.ids.includes(s.id)),
    }));
    const scaleRef =
      scaleToAll || layers.length ? bucketSeries(data, n, everySeries) : base;
    return { base, layers, yScale: yScaleFor(scaleRef, height) };
  }, [data, n, height, filterIds, highlights, scaleToAll]);
